import { render } from "./StatCounter.vue?vue&type=template&id=d051f020"
import script from "./StatCounter.vue?vue&type=script&lang=js"
export * from "./StatCounter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__